._limitlessZoom_1y9nb_1 {
  display: flex;
  flex-direction: row;
  gap: 2px;
  padding: 0px 8px;
  align-items: center; }
